import styled from "styled-components"
import ActionMenu from "./ActionMenu";
import React, {useContext, useState} from "react";
import {makeStyles, Menu, MenuItem} from "@material-ui/core";
import {SelectionCriteriaContext} from "./SelectionCriteriaContext";

export const types = {
    'or': {text: 'OR', borderColor: 'rgba(255,165,0,0.5)', background: '#ffa50045'},
    'and': {text: 'AND', borderColor: 'rgba(173,216,230,0.5)', background: '#add8e661'}
}
const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const useStyles = makeStyles(({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    }
}))

const StyledContainer = styled.div(props => ({
    marginLeft: (props.level + 1) * 12,
    // borderLeft: `3px solid ${types[props.type].borderColor}`,
    position: 'relative',
    paddingLeft: 5,
    paddingTop: 8,
    paddingBottom: 8,
    marginTop: 5,
    marginBottom: 5,
    display: 'flex',
    justifyContent: 'center',
    background: props.level % 2 !== 0 ? 'white' : 'aliceblue',
    borderRadius: 10
}))

const GroupContainer = ({type, level, children, path, index}) => {
    return (
        <StyledContainer type={type} level={level}>
            <div style={{
                position: 'relative',
                padding: 10,
                borderLeft: `3px solid ${types[type].borderColor}`,
                paddingLeft: 15,
            }}
            >
                <div style={{position: 'absolute', right: -28, top: 'calc(50% - 14px)',}}>
                    <ActionMenu/>
                </div>
                <Corners type={type}/>
                <ConnectorText type={type} path={path} index={index} />
                <div
                    style={{width: '100%'}}
                >
                    {children}
                </div>
            </div>
        </StyledContainer>)
}

export default GroupContainer


const Corners = ({type}) => {
    return <>
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: 5,
                borderTop: `3px solid ${types[type].borderColor}`
            }}/>
        <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: 5,
            borderTop: `3px solid ${types[type].borderColor}`
        }}/>
    </>
}

const ConnectorText = ({type, path, index}) => {
    const [anchorEl, setAnchorEl] = useState(initialContextState)
    const {addGroup, addItem, remove, changeOperator} = useContext(SelectionCriteriaContext)
    const classes = useStyles();

    function onClose() {
        setAnchorEl(initialContextState)
    }

    return (
        <div style={{
            background: '#fff',
            borderRadius: '20px',
            position: 'absolute',
            left: -21,
            top: 'calc(50% - 15px)',
            width: 40,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
        }}
        >
            <div style={{
                width: '95%',
                height: '95%',
                borderRadius: '20px',
                background: types[type].background,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',

            }}
                 onClick={e => {
                     setAnchorEl({
                         mouseX: e.clientX - 2,
                         mouseY: e.clientY - 4,
                     })
                 }}
            >
                <p style={{fontSize: 11, lineHeight: 0.5}}>{types[type].text}</p>
            </div>
            <Menu
                classes={{list: classes.contextPaper}}
                open={anchorEl.mouseY !== null}
                anchorReference={"anchorPosition"}
                anchorPosition={
                    anchorEl.mouseY !== null && anchorEl.mouseX !== null
                        ? {top: anchorEl.mouseY, left: anchorEl.mouseX}
                        : undefined
                }
                onClose={onClose}
            >
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        changeOperator(path, index, {current: type, updated: type === 'or' ? 'and' : 'or'})
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Change to {type === 'or' ? 'AND' : 'OR'}
                </MenuItem>
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        addItem(path, index, 0)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Add before
                </MenuItem>
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        addGroup(path, index, 0)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Add before group
                </MenuItem>
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        addItem(path, index, 1)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Add after
                </MenuItem>
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        addGroup(path, index, 1)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Add after group
                </MenuItem>
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        remove(path, index)
                        onClose();
                    }}
                >
                    {/*<ListItemIcon classes={{root: classes.listIconRoot}}>*/}
                    {/*    <Edit fontSize="small"/>*/}
                    {/*</ListItemIcon>*/}
                    Remove
                </MenuItem>
            </Menu>
        </div>
    )
}